import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家財xオプション関連（中間テーブル）
 */
export const yhc_kazai_option_services_kazais: ModelDef = {
  tableName: 'yhc_kazai_option_services_kazais',
  tableLabel: '見積:家財xオプション関連',
  primaryKeyColType: 'NUMBER',
  columns: {
    kazai: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      replicable: true,
      visible: false,
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_types',
        labelFormatter: (row) => row.name,
      },
    },
    service: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: 'オプションサービス',
      replicable: true,
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_option_services',
        labelFormatter: (row) => row.admin_title,
      },
    },
  },
}
